// Mock data for xpresedu website

export const mockCourses = [
  {
    id: 1,
    title: "Web Development Fundamentals",
    description: "Learn the basics of HTML, CSS, and JavaScript to build modern websites.",
    instructor: "John Smith",
    duration: "12 weeks",
    level: "Beginner",
    price: "₹15000",
    rating: 4.8,
    studentsEnrolled: 1250,
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    category: "Technology"
  },
  {
    id: 2,
    title: "Digital Marketing Mastery",
    description: "Master the art of digital marketing including SEO, social media, and content marketing.",
    instructor: "Sarah Johnson",
    duration: "8 weeks",
    level: "Intermediate",
    price: "₹20000",
    rating: 4.9,
    studentsEnrolled: 980,
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    category: "Marketing"
  },
  {
    id: 3,
    title: "Data Science with Python",
    description: "Dive deep into data analysis, machine learning, and visualization with Python.",
    instructor: "Dr. Michael Chen",
    duration: "16 weeks",
    level: "Advanced",
    price: "₹35000",
    rating: 4.7,
    studentsEnrolled: 750,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    category: "Data Science"
  },
  {
    id: 4,
    title: "Graphic Design Essentials",
    description: "Learn the principles of graphic design using Adobe Creative Suite.",
    instructor: "Emily Rodriguez",
    duration: "10 weeks",
    level: "Beginner",
    price: "₹18000",
    rating: 4.6,
    studentsEnrolled: 650,
    image: "https://images.unsplash.com/photo-1561736778-92e52a7769ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    category: "Design"
  },
  {
    id: 5,
    title: "Business Analytics",
    description: "Transform data into actionable business insights and strategic decisions.",
    instructor: "David Wilson",
    duration: "14 weeks",
    level: "Intermediate",
    price: "₹28000",
    rating: 4.8,
    studentsEnrolled: 540,
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    category: "Business"
  },
  {
    id: 6,
    title: "Mobile App Development",
    description: "Build native mobile applications for iOS and Android platforms.",
    instructor: "Alex Kim",
    duration: "20 weeks",
    level: "Advanced",
    price: "₹42000",
    rating: 4.9,
    studentsEnrolled: 420,
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    category: "Technology"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Software Developer",
    company: "TechCorp India",
    content: "xpresedu transformed my career! The courses are well-structured and the instructors are industry experts. I landed my dream job within 3 months of completing the web development course.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108755-2616c7ff90b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    role: "Digital Marketing Manager",
    company: "StartupXYZ",
    content: "The digital marketing course exceeded my expectations. The practical assignments and real-world projects helped me understand the concepts better. Highly recommended!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
  },
  {
    id: 3,
    name: "Anjali Patel",
    role: "Data Analyst",
    company: "Analytics Pro",
    content: "The data science program is comprehensive and challenging. The mentorship provided was invaluable in helping me transition from a non-tech background to data science.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
  }
];

export const mockInstructors = [
  {
    id: 1,
    name: "John Smith",
    expertise: "Full Stack Development",
    experience: "8+ years",
    students: 2500,
    rating: 4.9,
    bio: "Senior Software Engineer at Google with expertise in React, Node.js, and cloud technologies.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    expertise: "Digital Marketing",
    experience: "6+ years",
    students: 1800,
    rating: 4.8,
    bio: "Digital Marketing Director with proven track record in growing businesses through strategic online marketing.",
    image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
  },
  {
    id: 3,
    name: "Dr. Michael Chen",
    expertise: "Data Science & AI",
    experience: "12+ years",
    students: 1500,
    rating: 4.9,
    bio: "PhD in Computer Science, former Microsoft Research scientist specializing in machine learning and AI.",
    image: "https://images.unsplash.com/photo-1556157382-97eda2d62296?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
  }
];

export const mockWebinars = [
  {
    id: 1,
    title: "Future of AI in Education",
    date: "2025-02-15",
    time: "7:00 PM IST",
    speaker: "Dr. Michael Chen",
    duration: "90 minutes",
    attendees: 450,
    description: "Explore how artificial intelligence is revolutionizing the education sector and what it means for learners and educators.",
    image: "https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 2,
    title: "Building Your Personal Brand Online",
    date: "2025-02-20",
    time: "6:30 PM IST",
    speaker: "Sarah Johnson",
    duration: "60 minutes",
    attendees: 320,
    description: "Learn essential strategies to build and maintain a strong personal brand across digital platforms.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 3,
    title: "Career Transition in Tech",
    date: "2025-02-25",
    time: "8:00 PM IST",
    speaker: "John Smith",
    duration: "75 minutes",
    attendees: 280,
    description: "Navigate your career transition into the tech industry with practical tips and success strategies.",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
  }
];

export const mockContactInfo = {
  email: "support@learnmiles.in",
  phone: "77996 84747",
  address: "Flat no: 401, Plot no HIG 115, INTURI CHAMBERS, 6th Phase, KPHB Colony, Kukatpally, Hyderabad-500085",
  socialMedia: {
    facebook: "https://facebook.com/learnmiles",
    twitter: "https://twitter.com/learnmiles",
    linkedin: "https://linkedin.com/company/learnmiles",
    instagram: "https://instagram.com/learnmiles"
  }
};

export const mockFAQs = [
  {
    id: 1,
    question: "How do I enroll in a course?",
    answer: "You can enroll in any course by clicking the 'Enroll Now' button on the course page. You'll need to create an account and complete the payment process."
  },
  {
    id: 2,
    question: "Are the certificates recognized by industry?",
    answer: "Yes, our certificates are recognized by leading companies in the industry. We maintain partnerships with major employers who value our certification programs."
  },
  {
    id: 3,
    question: "Can I get a refund if I'm not satisfied?",
    answer: "We offer a 30-day money-back guarantee for all our courses. If you're not satisfied with the course content, you can request a full refund within 30 days of enrollment."
  },
  {
    id: 4,
    question: "Do you provide career support after course completion?",
    answer: "Yes, we offer career mentoring, resume review, interview preparation, and job placement assistance to all our students even after course completion."
  },
  {
    id: 5,
    question: "Are the courses self-paced or scheduled?",
    answer: "Most of our courses are self-paced, allowing you to learn at your convenience. However, we also offer live webinars and scheduled sessions for interactive learning."
  }
];

